export const frData = `
  <div class="paragraph">
    <div class="page-title">Foire aux questions sur le programme de reprise (Trade-In)</div>
  </div>
  <div class="paragraph">
    <div class="title">Qui peut participer au programme de reprise?</div>
    <div class="text-box">
      <div class="text">
        Le service de reprise est exclusivement disponible pour les personnes âgées de 18 ans ou plus résidant légalement dans un État membre de l’Union européenne, à l’exclusion des îles Canaries, des îles Baléares, de Ceuta et de Melilla.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que dois-je faire avant d’envoyer mon ancien appareil?</div>
    <div class="text-box">
      <div class="text">
        Avant d’envoyer votre appareil:<br>
        •	Supprimez toutes les données personnelles et retirez tout code PIN, mot de passe ou schéma de verrouillage d’écran.<br>
        •	Effectuez une réinitialisation complète aux paramètres d’usine.<br>
        •	Sur iPhone: déconnectez votre compte iCloud en désactivant la fonction « Localiser mon iPhone ».<br>
        •	Sur Android: supprimez votre compte Google (Paramètres > Comptes > Google > Supprimer le compte).<br>
        •	Pour les caméras d’action : Supprimez tout compte lié, effacez tous les fichiers multimédias, formatez la carte mémoire (le cas échéant) et effectuez une réinitialisation complète aux paramètres d’usine.<br>
        Cela garantit que l’appareil n’est plus lié à votre compte et protège vos informations personnelles.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Comment puis-je envoyer mon ancien appareil?</div>
    <div class="text-box">
      <div class="text">
        <strong>Emballage:</strong> utilisez une boîte solide et opaque (non transparente) et ajoutez une protection interne (papier bulle ou équivalent) pour éviter tout dommage pendant le transport.<br>
        <strong>Matériaux d’emballage:</strong> si vous ne disposez pas du matériel d’emballage approprié, vous pouvez en demander sur le point de dépôt au moment de remettre votre colis.<br>
        <strong>Documentation:</strong> imprimez, remplissez et signez la Déclaration d’honnêteté, puis placez-la dans le colis avant de le fermer.<br>
        <strong>Fermeture sécurisée:</strong> assurez-vous que le colis soit correctement scellé et fixez l’étiquette d’expédition gratuite dans un endroit bien visible.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Quels types d’appareils ne sont pas acceptés?</div>
    <div class="text-box">
      <div class="text">
        Nous n’acceptons pas les appareils qui:<br>
        •	so sont verrouillés par un opérateur (SIM-lock) ;<br>
        •	ne s’allument pas ou ne se chargent pas ;<br>
        •	ne peuvent pas se connecter via Bluetooth ou Wi-Fi ;<br>
        •	présentent une défaillance de composants internes ou de la carte mère ;<br>
        •	ne peuvent pas prendre de photos ou enregistrer des vidéos correctement; <br>
        •	ont des lentilles fissurées ou des dommages structurels graves ;<br>
        •	pr présentent des boutons défectueux ou des problèmes de stabilisation ;<br>
        •	ont été exposés à un liquide ou ont été réparés/démontés ;<br>
        •	sont toujours liés à iCloud, Google ou à tout autre compte utilisateur ;<br>
        •	sont des contrefaçons ou des répliques ;<br>
        •	sont gravement endommagés.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Dois-je envoyer les accessoires (chargeur, câble, etc.)?</div>
    <div class="text-box">
      <div class="text">
        Ce n’est pas obligatoire, mais recommandé. Inclure les accessoires contribue à la durabilité et à une réutilisation appropriée.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Dois-je envoyer les écouteurs?</div>
    <div class="text-box">
      <div class="text">
        Non. Pour des raisons d’hygiène, les écouteurs seront écartés et ne seront pas pris en compte lors de l’évaluation.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Dois-je envoyer la facture d’achat?</div>
    <div class="text-box">
      <div class="text">
        Non, la facture n’est pas requise pour l’évaluation ni pour le paiement. Vous pouvez la conserver pour vos propres dossiers.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Comment mon ancien appareil est-il évalué?</div>
    <div class="text-box">
      <div class="text">
        Nous utilisons un logiciel de diagnostic certifié et procédons à une inspection manuelle dans notre centre d’évaluation pour déterminer l’état de votre appareil. Toutes les procédures d’évaluation et de traitement des données sont conformes au Règlement général sur la protection des données (RGPD – UE 2016/679), garantissant la sécurité et la confidentialité de vos informations.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que se passe-t-il si l’état que j’ai indiqué ne correspond pas à votre évaluation ?</div>
    <div class="text-box">
      <div class="text">
        S’il existe des différences entre l’état déclaré et notre évaluation, nous vous enverrons un e-mail contenant:<br>
        •	<strong>Une offre mise à jour</strong> basée sur l’inspection réelle.<br>
        •	<strong>Le rapport de diagnostic</strong> et les raisons de la différence constatée.<br><br>
        Vous pouvez accepter ou refuser l’offre:<br>
        •	Si vous acceptez, la reprise sera finalisée et vous recevrez le paiement sur votre compte bancaire dans un délai de 3 jours ouvrables.<br>
        •	• Si vous refusez, le processus de retour dépendra de votre lieu de résidence:<br>
        &nbsp;&nbsp;•	Pour tous les clients, des frais de retour s’appliquent, dans la limite maximale de 22 € (TVA incluse).<br>
        &nbsp;&nbsp;•	Les frais doivent être réglés dans un délai de cinq (5) jours calendaires suivant la réception de la demande de paiement, en utilisant l’étiquette officielle de retour prépayée fournie par Danghuan.<br>
        &nbsp;&nbsp;•	Les informations de paiement seront fournies sur demande ou incluses dans l’e-mail contenant le lien de paiement.<br>
        &nbsp;&nbsp;•	Une fois le paiement confirmé, Danghuan vérifiera la transaction dans un délai de cinq (5) jours ouvrables et organisera l’expédition du retour à l’adresse d’origine. Le client sera informé par e-mail dès l’expédition du colis, avec les informations de suivi correspondantes.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que se passe-t-il si je ne réponds pas à l’offre mise à jour?</div>
    <div class="text-box">
      <div class="text">
        En l’absence de réponse dans un délai de cinq (5) jours calendaires à compter de la date de notification, l’offre révisée sera réputée automatiquement acceptée, sans autre notification, rappel ou communication supplémentaire de la part de Danghuan.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que devient-il de mes données personnelles?</div>
    <div class="text-box">
      <div class="text">
        Vous devez supprimer toutes les données avant d’envoyer votre ancien appareil.<br>
        Si nous détectons des données restantes, nous suspendrons le processus et vous contacterons pour les effacer. Nous respectons pleinement le RGPD (Règlement UE 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Qui prend en charge les frais d’expédition?</div>
    <div class="text-box">
      <div class="text">
        La première expédition est toujours gratuite.<br><br>
        Si vous refusez l’offre mise à jour:<br>
        •	Pour tous les clients, des frais de retour s’appliquent, dans la limite maximale de 22 € (TVA incluse).<br>
        •	Les frais doivent être réglés dans un délai de cinq (5) jours calendaires suivant la réception de la demande de paiement, en utilisant l’étiquette officielle de retour prépayée fournie par Danghuan.<br>
        •	Les informations de paiement seront fournies sur demande ou incluses dans l’e-mail contenant le lien de paiement.<br>
        •	Une fois le paiement confirmé (le cas échéant), Danghuan vérifiera la transaction dans un délai de 5 jours ouvrables et organisera l’expédition de retour à votre adresse d’origine. Vous serez notifié par e-mail lorsque le colis sera expédié, avec les informations de suivi correspondantes.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que se passe-t-il si mon colis est perdu pendant le transport?</div>
    <div class="text-box">
      <div class="text">
        Si votre appareil est perdu pendant le transport, Danghuan Europe S.L. vous assistera dans la procédure officielle de réclamation auprès du transporteur.<br><br>
        Un envoi est considéré comme perdu s’il n’a pas été suivi, confirmé ou reçu par Danghuan dans un délai de 15 jours calendaires après sa remise au transporteur.<br><br>
        •	Vous devez utiliser l’étiquette d’expédition prépayée autorisée par Danghuan ; l’utilisation d’une autre méthode annule la couverture en cas de perte.<br>
        •	Les réclamations auprès de UPS doivent être déposées dans les 60 jours suivant la création de l’étiquette.<br>
        •	Pour les envois via CORREOS (Espagne), les réclamations doivent être déposées dès que possible, de préférence dans les 15 jours, et au plus tard dans un délai d’un an à compter de la date d’expédition.<br>
        •	Danghuan assistera à l’enquête du transporteur, qui dure généralement 30 à 60 jours.<br><br>
        Si la perte est confirmée dans le système logistique de Danghuan et que l’étiquette autorisée a été utilisée, l’indemnisation ne dépassera pas la valeur finale estimée de reprise de l’appareil.<br><br>
        Les paiements approuvés seront versés directement sur l’IBAN fourni lors de l’inscription.<br><br>
        <em>Remarque : toute indemnisation dépend de la politique du transporteur concerné.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Quand recevrai-je le paiement?</div>
    <div class="text-box">
      <div class="text">
        Une fois l’offre finale acceptée, le paiement sera effectué par virement bancaire dans un délai de 3 jours ouvrables. Veuillez vous assurer que votre IBAN et votre numéro d’identification personnel sont corrects et correspondent au titulaire du compte.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Est-il obligatoire de fournir mon numéro d’identification personnel?</div>
    <div class="text-box">
      <div class="text">
        Oui. Pour traiter le paiement, vous devez fournir un numéro d’identification personnel valide, sans espaces ni caractères spéciaux, correspondant au titulaire du compte IBAN.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Puis-je annuler ma demande de reprise?</div>
    <div class="text-box">
      <div class="text">
        Oui, si votre ancien appareil n’a pas encore été payé. Veuillez nous contacter dès que possible à l’adresse insta360@danghuan.eu. Si vous avez déjà envoyé votre appareil, contactez-nous dans un délai de 48 heures ; sinon, le processus de recyclage se poursuivra normalement.
      </div>
    </div>
  </div>
`;